exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/modules/_object-gops.js
// module id = 1336
// module chunks = 0